'use client'

import { Card, Cell, Image, Text } from '@vinted/web-ui'
import classNames from 'classnames'
import { MouseEvent } from 'react'

import { useAsset } from '@marketplace-web/shared/assets'
import { DropOffPointModel } from '@marketplace-web/conversation-shipping/conversation-shipping-data'

type Props = {
  show: boolean
  dropOffPoint: DropOffPointModel
  onClick: (event: MouseEvent) => void
  isActive: boolean
  id: number
}

const DROP_OFF_POINT_PHOTO_PLACEHOLDER = 'pickup-placeholder.svg'

const DropOffPointInfoWindow = ({ show, dropOffPoint, onClick, id, isActive }: Props) => {
  const asset = useAsset('/assets/shipping')

  if (!show) return null

  const infoWindowClass = classNames('drop-off-point-map__info-window', {
    'drop-off-point-map__info-window--active': isActive,
  })

  return (
    <div className={infoWindowClass} data-testid={`drop-off-info-window-${id}`}>
      <Card styling="lifted">
        <div className="u-overflow-hidden">
          <Cell
            type="navigating"
            onClick={onClick}
            prefix={
              <Image
                src={dropOffPoint.photoUrl || asset(DROP_OFF_POINT_PHOTO_PLACEHOLDER)}
                fallbackSrc={asset(DROP_OFF_POINT_PHOTO_PLACEHOLDER)}
                size="x-large"
                styling="rounded"
                alt=""
              />
            }
          >
            <Text as="h2" text={dropOffPoint.name} type="title" width="parent" truncate />
            <Text as="span" text={dropOffPoint.dropOffPointAddress} width="parent" truncate />
          </Cell>
        </div>
      </Card>
    </div>
  )
}

export default DropOffPointInfoWindow
